import { useState } from 'react'
import { toast } from '@wiggui/ds/Toast'
import { getPropertyDetail } from '../../../services'
import { useModalSearchIdStore } from '../../../store'
import { ROUTES } from '../../../constants'
import useRoles from '@wiggot/auth/hooks/useRoles'

export const useModalSearchId = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [searchId, setSearchId] = useState('')
  const { isAdminAgency } = useRoles()

  const modalSearchIdIsOpen = useModalSearchIdStore((state) => state?.isOpen)
  const searchFrom = useModalSearchIdStore((state) => state.searchFrom)

  const resetModalSearchId = useModalSearchIdStore((state) => state.reset)

  const onClose = () => {
    setSearchId('')
    resetModalSearchId()
  }

  const redirectToDetail = (property: any) => {
    const url = `${window.location.origin}/my-properties/property-detail/${property.propertyId}`
    window.open(url, '_blank')
  }

  const handleOnClick = async () => {
    setIsLoading(true)
    try {
      const { isSuccess, data } = await getPropertyDetail({
        id: searchId,
        search_from: searchFrom
      })

      if (isSuccess && data) {
        const isOwned = Boolean(
          data?.userOwned === 1 || (data?.agencyOwned === 1 && isAdminAgency)
        )
        const statusNotPermit = ['DELETED_RECENTLY', 'DELETED']
        const isDeleted =
          statusNotPermit.includes(data?.publishingStatus) ||
          statusNotPermit.includes(data?.propertyStatus as string)

        const status = data.pendingType || data.publishingStatus

        if (!isOwned) {
          redirectToDetail(data)
          return
        }

        const paramV2 =
          status === 'PENDING_TO_ASSIGN' || status === 'PENDING' || isDeleted
            ? 'edition'
            : 'diffusion'

        window.location.href = `${ROUTES.PROPERTY_DETAIL_V2(
          searchId
        )}?tab=${paramV2}`
        resetModalSearchId()
        return
      }

      toast({
        type: 'error',
        title: 'No se encontró la propiedad con el ID ingresado'
      })
    } catch {
      toast({
        type: 'error',
        title: 'No se encontró la propiedad con el ID ingresado'
      })
    } finally {
      setIsLoading(false)
      setSearchId('')
    }
  }
  return {
    onClose,
    handleOnClick,
    isLoading,
    modalSearchIdIsOpen,
    searchId,
    setSearchId
  }
}
